import { Dispatch, SetStateAction } from "react";
import useTableRendering from "../../../hooks/table/useTableRendering";
import { TableConfig } from "../../../types/Components/Table/TableConfig";
import { PaginationConfig } from "../../../types/Components/Table/PaginationConfig";
import TableIndicatorAlert from "../Alert/TableIndicatorAlert";
import { useForm } from "react-hook-form";
import { AuthUser } from "../../../types/User/AuthUser";

interface UseIndicatorAlertsProps {
  user: AuthUser;
  setIsSearching: Dispatch<SetStateAction<boolean>>;
  indicatorAlertsDataTable: any[];
  originalIndicatorAlertsDataTable: any[];
  setIndicatorAlertsDataTable: Dispatch<SetStateAction<any[]>>;
  isLoadedIndicatorAlerts: boolean;
  indicatorAlertsPageSize: number;
  setIndicatorAlertsPageSize: Dispatch<SetStateAction<number>>;
  indicatorAlertsTotalItems: number;
}

export const useIndicatorAlerts = ({
  user,
  setIsSearching,
  indicatorAlertsDataTable,
  originalIndicatorAlertsDataTable,
  setIndicatorAlertsDataTable,
  isLoadedIndicatorAlerts,
  indicatorAlertsPageSize,
  setIndicatorAlertsPageSize,
  indicatorAlertsTotalItems,
}: UseIndicatorAlertsProps) => {
  const { control, setValue, getValues } = useForm();

  const tableConfigIndicatorAlerts: TableConfig = {
    tableName: "Lista de indicadores e respectivos estados de alerta",
    dataTable: indicatorAlertsDataTable,
    originalDataTable: originalIndicatorAlertsDataTable,
    setDataTable: setIndicatorAlertsDataTable,
    renderTable: (indicatorAlertsDataTable) => (
      <TableIndicatorAlert
        dataTable={indicatorAlertsDataTable}
        originalDataTable={originalIndicatorAlertsDataTable}
        isLoaded={isLoadedIndicatorAlerts}
        setValue={setValue}
        getValues={getValues}
        control={control}
        setIsSearching={setIsSearching}
        user={user}
      />
    ),
    isLoaded: isLoadedIndicatorAlerts,
  };

  const {
    currentPage: indicatorAlertsCurrentPage,
    totalPages: indicatorAlertsTotalPages,
    handlePageChange: indicatorAlertsHandlePageChange,
    renderContent: indicatorAlertsRenderContent,
  } = useTableRendering(
    tableConfigIndicatorAlerts,
    indicatorAlertsPageSize,
    indicatorAlertsTotalItems,
    setIsSearching,
  );

  const paginationConfigIndicatorAlerts: PaginationConfig = {
    pageSize: indicatorAlertsPageSize,
    currentPage: indicatorAlertsCurrentPage,
    totalPages: indicatorAlertsTotalPages,
    handlePageChange: indicatorAlertsHandlePageChange,
    renderContent: indicatorAlertsRenderContent,
    setPageSize: setIndicatorAlertsPageSize,
    totalItems: indicatorAlertsTotalItems,
  };

  return {
    paginationConfigIndicatorAlerts,
    tableConfigIndicatorAlerts,
    indicatorAlertsCurrentPage,
  };
};
